/* tslint:disable */

declare var Object: any;
export interface JobLocationInterface {
  "Name"?: string;
  "sfdcId"?: string;
  "OwnerId"?: string;
  "LastModifiedById"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "ts2__City__c"?: string;
  "ts2__Client__c"?: string;
  "ts2__Country__c"?: string;
  "ts2__Location__c"?: number;
  "ts2__Metro__c"?: string;
  "ts2__PostalCode__c"?: string;
  "ts2__State__c"?: string;
  "ts2__Street__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobLocation implements JobLocationInterface {
  "Name": string;
  "sfdcId": string;
  "OwnerId": string;
  "LastModifiedById": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "ts2__City__c": string;
  "ts2__Client__c": string;
  "ts2__Country__c": string;
  "ts2__Location__c": number;
  "ts2__Metro__c": string;
  "ts2__PostalCode__c": string;
  "ts2__State__c": string;
  "ts2__Street__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobLocationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobLocation`.
   */
  public static getModelName() {
    return "JobLocation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobLocation for dynamic purposes.
  **/
  public static factory(data: JobLocationInterface): JobLocation{
    return new JobLocation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobLocation',
      plural: 'JobLocations',
      path: 'JobLocations',
      idName: 'id',
      properties: {
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "ts2__City__c": {
          name: 'ts2__City__c',
          type: 'string'
        },
        "ts2__Client__c": {
          name: 'ts2__Client__c',
          type: 'string'
        },
        "ts2__Country__c": {
          name: 'ts2__Country__c',
          type: 'string'
        },
        "ts2__Location__c": {
          name: 'ts2__Location__c',
          type: 'number'
        },
        "ts2__Metro__c": {
          name: 'ts2__Metro__c',
          type: 'string'
        },
        "ts2__PostalCode__c": {
          name: 'ts2__PostalCode__c',
          type: 'string'
        },
        "ts2__State__c": {
          name: 'ts2__State__c',
          type: 'string'
        },
        "ts2__Street__c": {
          name: 'ts2__Street__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
